import apiClient from './apiClient';

export const recoveryWalletApi = {
  // Get recovery wallet details
  getWallet: (userId) => apiClient.get(`/api/recovery-wallet/${userId}`),
  
  // Get recovery wallet transaction history  
  getTransactions: (userId, params = {}) => 
    apiClient.get(`/api/recovery-wallet/${userId}/transactions`, { params }),
  
  // Get recovery wallet statistics
  getStats: (userId) => apiClient.get(`/api/recovery-wallet/${userId}/stats`),
  
  // Withdraw recovery tokens (50% to main wallet)
  withdraw: (userId) => apiClient.post(`/api/recovery-wallet/${userId}/withdraw`)
};
